var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 572,
    height: 2,
    viewBox: "0 0 572 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 572,
    height: 2,
    fill: "#373737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLine);
export default __webpack_public_path__ + "static/media/FooterLine.7265799994f84ea8876cc7352ec5f273.svg";
export { ForwardRef as ReactComponent };